import React from 'react'
import FLAG_DEFAULTS from '@/services/feature-flags/flags'

const FeatureFlagsContext = React.createContext(FLAG_DEFAULTS)

export default FeatureFlagsContext
